import { encrypt, decrypt } from '@shared/crypt'

export type AuthSecretProps = { accessToken: string, refreshToken: string, user: any }
export type AuthReducerPros = { type: string, secret: AuthSecretProps, token: any }

const storageName = 'msbcc'

const getSecret = () => {
  let secret = sessionStorage.getItem(storageName)
  if (typeof secret !== 'string') return null
  secret = decrypt(secret)
  if (typeof secret !== 'string' || secret[0] !== '{') return null
  let result = JSON.parse(secret)
  return result
}

const setSecret = (secret: AuthSecretProps) => {
  sessionStorage.setItem(storageName, encrypt(JSON.stringify(secret)))
}

const removeSecret = () => {
  sessionStorage.removeItem(storageName)
}

const updateLocalAccessToken = (token: string) => {
  let secret = getSecret()
  if (secret) {
    secret.accessToken = token
    setSecret(secret)
  }
}

const updateLocalUser = (user: any) => {
  let secret = getSecret()
  if (secret) {
    secret.user = user
    setSecret(secret)
  }
}

const TokenService = {
  getSecret,
  setSecret,
  removeSecret,
  updateLocalAccessToken,
  updateLocalUser,
}

export default TokenService